var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPauseLg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_45809",
    "data-name": "Group 45809",
    transform: "translate(-0.002 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_1",
    "data-name": "Exclusion 1",
    d: "M32.5,65A32.5,32.5,0,0,1,9.52,9.521,32.5,32.5,0,0,1,55.482,55.483,32.291,32.291,0,0,1,32.5,65Zm7.129-44.312a2.986,2.986,0,0,0-2.778,3.15V40.332a2.985,2.985,0,0,0,2.778,3.149A2.982,2.982,0,0,0,42.4,40.332V23.838A2.983,2.983,0,0,0,39.628,20.688Zm-14.7,0a2.986,2.986,0,0,0-2.778,3.15V40.332a2.985,2.985,0,0,0,2.778,3.149,2.984,2.984,0,0,0,2.782-3.149V23.838A2.985,2.985,0,0,0,24.933,20.688Z",
    transform: "translate(0.002 -0.002)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseLg);
export default __webpack_public_path__ + "static/media/pause_lg.f9483fa23d28d5fae3d7628c8321acef.svg";
export { ForwardRef as ReactComponent };